/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { CardContext } from "./card";

const cardFooterVariants = cva("flex items-center", {
  variants: {
    size: {
      default: "px-4 pb-4 pt-1",
      sm: "px-3 pb-3 pt-1",
      lg: "px-5 pb-5 pt-2",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const cardFooterBgSizeVariants = cva("", {
  variants: {
    size: {
      default: "pt-3",
      sm: "pt-2",
      lg: "pt-4",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { size } = React.useContext(CardContext);

  return (
    <div
      ref={ref}
      className={cn(
        cardFooterVariants({ size }),
        className?.startsWith("bg-") || className?.includes(" bg-")
          ? cardFooterBgSizeVariants({ size })
          : undefined,
        className,
      )}
      {...props}
    />
  );
});
CardFooter.displayName = "CardFooter";

export { CardFooter, cardFooterBgSizeVariants, cardFooterVariants };
